export default __webpack_public_path__ + "static/media/benefit_16@2x.0b7fa3fd.png";